<template>
  <div>
    <div style="page-break-after: always;">
      <div style="width: 100%; text-align: center">
        <button class="btn " id="printbtn" onclick="window.print();" type="button"><i class="fa fa-print"></i> Print Form</button>
      </div>
      <table width="100%">
        <tr>
          <td width="20%">
            <img v-bind:src="institue.Logo" style="width: 100px; height: 100px;">
          </td>
          <td width="60%" style="text-align: center">
            <h3 style="margin-bottom: 0px;">
              {{institue.Name}}
            </h3>
            <h4 style="margin-top: 5px; margin-bottom: 0px;">
              EMPLOYEE PROFILE FORM
            </h4>
          </td>
          <td width="20%" style="text-align: right;">
            <div style="text-align: center; float:right">
              <!--<img id="img" v-bind:src="employeeinfo[0].Image" style="width: 100px; height: 115px;" alt="profile-image">-->
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
        </tr>
      </table>

      <table width="100%">
        <tr>
          <td width="80%">
            <table width="100%" style="margin-top: 0px; font-size: 12px;">
              <tr>
                <td align="left">
                  <h2>Personal Information</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" style="font-size: 12px; text-align: left;">
                    <tr>
                      <th width="20%" align="left">Name:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Name}}</label>
                      </td>
                      <th width="20%" align="left">Fathers's Name:</th>
                      <td width="30%" align="left">
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].FathersName}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Date of Birth:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].date}}</label>
                      </td>
                      <th>CNIC # / B Form #:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].CNIC}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Gender:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Gender}}</label>
                      </td>
                      <th>Nationality:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Nationality}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Religion:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Religion}}</label>
                      </td>
                      <th>Email:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Email}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Mobile No.:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].ContactNo}}</label>
                      </td>
                      <th>City:</th>
                      <td>
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].City}}</label>
                      </td>
                    </tr>

                    <tr>
                    </tr>
                    <tr>
                      <th>Permanent Address:</th>
                      <td align="left">
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Address}}</label>
                      </td>
                      <th>Present/Postal Address:</th>
                      <td align="left">
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].Address}}</label>
                      </td>
                    </tr>
                    <tr>
                      <th>Postal Code:</th>
                      <td align="left">
                        <label style="border-bottom: 1px solid black;">{{employeeinfo[0].ZipCode}}</label>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Academic Record</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Certificate/Degree</th>
                      <th>Passing Year</th>
                      <th>Board/University</th>
                      <th>Total Marks</th>
                      <th>Obtained Marks</th>
                      <th>%</th>
                      <th>Grade</th>
                    </tr>
                    <tr v-for="item in employee_Education">
                      <td>{{item.DegreeTitle}} </td>
                      <td align="center">{{item.PassingYear}} </td>
                      <td>{{item.Institute}} </td>
                      <td align="right">{{item.TotalMarks}} </td>
                      <td align="right">{{item.ObtainedMarks}}</td>
                      <td align="right">{{((Number(item.ObtainedMarks) * 100) / Number(item.TotalMarks)).toFixed(3)}}</td>
                      <td>{{item.Division}} </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Professional Training </h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Title</th>
                      <th>Diploma/Certificate</th>
                      <th>Field of study</th>
                      <th>Institution</th>
                      <th>Grade if any</th>
                    </tr>
                    <tr v-for="item in employee_ProfessionalTraning">
                      <td>{{item.Title}} </td>
                      <td align="center">{{item.Type}} </td>
                      <td>{{item.FieldOfStudy}} </td>
                      <td>{{item.Institution}} </td>
                      <td align="right">{{item.Grade}} </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Extra/Co-curricular Activities/Hobbies/Interests (if any)</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Employment History</h2>
                  <hr />
                </td>
                <!--</tr>
                <tr>
                  <td align="left">
                    <h2>(a)	Teaching</h2>
                    <hr />
                  </td>
                </tr>
                <tr>
                  <td>
                    <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                      <tr style="background-color: black !important; color: white">
                        <th>Name of Organization</th>
                        <th>Designation</th>
                        <th>Pay Scale</th>
                        <th>Job Profile</th>
                        <th>Duration Time</th>
                      </tr>
                      <tr v-for="item in employee_Teaching">
                        <td>{{item.Institute}} </td>
                        <td align="center">{{item.Designation}} </td>
                        <td> </td>
                        <td>{{item.InstituteName}} </td>
                        <td align="right">{{item.Grade}} </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="left">
                    <h2>(b)	Industrial (if any)</h2>
                    <hr />
                  </td>
                </tr>
                <tr>
                  <td>
                    <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                      <tr style="background-color: black !important; color: white">
                        <th>Name of Organization</th>
                        <th>Designation</th>
                        <th>Pay Scale</th>
                        <th>Job Profile</th>
                        <th>Duration Time</th>
                      </tr>
                      <tr v-for="item in prospect_student_Education">
                        <td>{{item.Title}} </td>
                        <td align="center">{{item.Certificate}} </td>
                        <td>{{item.FieldOfStudy}} </td>
                        <td>{{item.InstituteName}} </td>
                        <td align="right">{{item.Grade}} </td>
                      </tr>
                    </table>
                  </td>
                </tr>-->
              <tr>
                <td align="left">
                  <h2>Research Publications</h2>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>(a)	National/ International Journal Papers (Attach additional sheet if required)</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Title of Publication</th>
                      <th>Complete Name of Journal and Address</th>
                      <th>Vol.No.</th>
                      <th>Page No.</th>
                      <th>Year</th>
                      <th>HEC approved Category</th>
                      <th>Impact Factor</th>
                    </tr>
                    <tr v-for="item in employee_JournalPaper">
                      <td>{{item.Title}} </td>
                      <td align="center"> </td>
                      <td>{{item.VolumnNo}} </td>
                      <td>{{item.PageNo}} </td>
                      <td align="right">{{item.Year}} </td>
                      <td align="right">{{item.HECApprovedCategory}} </td>
                      <td align="right">{{item.ImpactFactor}} </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>(b)	National/ International Conference Papers (Attach additional sheet if required)</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Title of Publication</th>
                      <th>Conference</th>
                      <th>Year</th>
                      <th>Venue</th>
                    </tr>
                    <tr v-for="item in employee_ConferencePaper">
                      <td>{{item.Title}} </td>
                      <td align="center">{{item.Conference}} </td>
                      <td>{{item.Year}} </td>
                      <td>{{item.Venue}} </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>(c)	Book/ Book Chapter Written (if any) – Attach additional sheet if required</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Title</th>
                      <th>Subject/ Description</th>
                      <th>Publisher (if any)</th>
                    </tr>
                    <tr v-for="item in employee_BookPublication">
                      <td>{{item.Title}} </td>
                      <td align="center">{{item.Subject}} </td>
                      <td>{{item.Publisher}} </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>(d)	Lab Manual (if any)</h2>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%" border="1" cellspacing="0" style="font-size: 12px; text-align: left;">
                    <tr style="background-color: black !important; color: white">
                      <th>Title</th>
                      <th>Subject/ Description</th>
                      <th>Publisher (if any)</th>
                    </tr>
                    <tr v-for="item in employee_LabManual">
                      <td>{{item.Title}} </td>
                      <td align="center">{{item.Subject}} </td>
                      <td>{{item.Publisher}} </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h2>Reference:- Provide Two Academic/Professional References</h2>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <h3>Reference No: 1</h3>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  Name: ___________________________________
                  Position: _______________________________
                </td>
              </tr>
              <tr>
                <td>
                  Address: ______________________________________________________________________________________________________
                  Phone No: _______________________________
                </td>
              </tr>
              <tr>
                <td>Email: ______________________________________________________________</td>
              </tr>

              <tr>
                <td align="left">
                  <h3>Reference No: 2</h3>
                  <hr />
                </td>
              </tr>
              <tr>
                <td>
                  Name: ___________________________________
                  Position: _______________________________
                </td>
              </tr>
              <tr>
                <td>
                  Address: ______________________________________________________________________________________________________
                  Phone No: _______________________________
                </td>
              </tr>
              <tr>
                <td>Email: ______________________________________________________________</td>
              </tr>
              <!--<tr>
                <td>
                  <p style="margin-top:20px">
                    By signing below and submitting this application form I, -----------------------------------------------,
                    confirm that the information I have provided is accurate to the best of my knowledge and that
                    I authorize you to contact the references provided above for further information.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="float:left; margin-top:50px">Date: __________________</span>
                  <span style="border-top: 1px solid black; float: right; margin-top: 50px">Signature Of the Applicant</span>
                </td>
              </tr>
              <tr style="page-break-after: always">
                <td style="margin-top:50px">
                  <h3 style="text-align:center">Your Teaching Philosophy & Skills</h3>
                  <br />
                  <h3 style="text-align:center">(500 words)</h3>
                </td>
              </tr>-->
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({

    data() {
      return {
        employeeinfo: [],
        institue: [],
        terms: '',
        employee_Education: [],
        employee_ProfessionalTraning: [],
        employee_Teaching: [],
        employee_Industrial: [],
        employee_JournalPaper: [],
        employee_ConferencePaper: [],
        employee_BookPublication: [],
        employee_LabManual: [],
        short_name: "",
        program_id_1: '0',
        short_name_2: "",
        program_id_2: '0',
        amount: 0,
        choices: [], image: '', sum: 0, choices2: [],
        fam: { GuardiansName: '', GuardiansCNIC: '', Occupation: '', MonthlyIncome: '', MothersCNIC: '', PhoneNo: '', MothersName: '', MotherOccupation: '', MotherIncome: '', MotherPhoneNo: '', NoOfBrothers: '', NoOfSisters: '', DependentBrotherSister: '', YourNoByOrderBirth: '', SiblingStudyInFJWU: '', LanguageSpokenAtHome: '' }
      }
    },

    created: function () {
      this.get_student_info();
    },

    methods: {
      get_student_info() {
        var vm = this;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var id = urlParams.get("id");
        axios.post('/api/EmployeesApi/LoadEmployeeProfilePrint?id=' + id)
          .then(function (response) {
            vm.employeeinfo = response.data["lst"];
            vm.employee_Education = response.data["edu"];
            vm.employee_ProfessionalTraning = response.data["profTraning"];
            vm.employee_Teaching = response.data["Teachinghistory"];
            vm.employee_Industrial = response.data["industrialHistory"];
            vm.employee_JournalPaper = response.data["journalProp"];
            vm.employee_ConferencePaper = response.data["conferencePaper"];
            vm.employee_BookPublication = response.data["book"];
            vm.employee_LabManual = response.data["LabManual"];
            //vm.amount = response.data["amount"];
            //vm.program_id_1 = response.data.ProgramID;
            //vm.terms = response.data.terms;
            vm.institue = response.data.institue;
            //vm.image = vm.employeeinfo[0].Image;
          })
          .catch(function (Error) {
            console.log(Error);
          });
      },
    }

  })
</script>

<style>
  body {
    font-size: 10px;
  }

  .padding {
    padding: 0px;
  }

  .margin {
    margin: 0px;
  }

  .fontSize {
    font-size: 10px;
  }

  hr {
    margin-top: -12px;
  }

  @page {
    size: portrait;
  }

  @media print {
    #printbtn {
      display: none;
    }
  }

  .btn {
    background-color: #438eb9;
    color: white;
    padding-top: 4px;
    padding-bottom: 4px;
    cursor: pointer;
  }

  #img {
    padding: 1px;
    border: 1px solid #021a40;
  }
</style>



// WEBPACK FOOTER //
// src/components/hr/employeeprofileprint.vue